module.exports = __webpack_public_path__ + "static/media/professional.5030fdd9.svg";